/* eslint-disable max-len */
import React from 'react';

interface CheckIconProps {
  className?: string;
  size: number;
}

const CheckIcon = ({ className = '', size = 20 }: CheckIconProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 1L6 12L1 7"
      stroke="#2F96E8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckIcon;
